import Vue from 'vue'
import Vuex from 'vuex'
import common from './modules/common';
import auth from './modules/auth';
import user from './modules/user';
import marshal from './modules/marshal';
import admin from './modules/ptspAdmin';
import merchant from './modules/merchant';
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
    modules: {
        common,
        auth,
        user,
        marshal,
        admin,
        merchant
    },
    strict: debug,
    plugins: [createPersistedState()],
})
